const sharedStart = 'https://i8.amplience.net/v/';

const speedToQuality = {
  '2g': '240p',
  '3g': '480p',
  '4g': '720p',
};

export const buildVidUrlWebM = (assetObj: any, width: number | string, speed: number | string) => {
  const widthString = width ? `width=${width}` : '';

  if (assetObj) {
    return `${sharedStart}${assetObj.endpoint}/${assetObj.name}/webm_${speedToQuality[speed as keyof typeof speedToQuality]}?preload=auto&loop=true&${widthString}&protocol=https`;
  }
  return 'https://i8.amplience.net/i/traeger/image-placeholder-icon';
};

export const buildVidUrlMP4 = (assetObj: any, width: number | string, speed: number | string) => {
  const widthString = width ? `width=${width}` : '';

  if (assetObj) {
    return `${sharedStart}${assetObj.endpoint}/${assetObj.name}/mp4_${speedToQuality[speed as keyof typeof speedToQuality]}?preload=auto&loop=true&${widthString}&protocol=https`;
  }
  return 'https://i8.amplience.net/i/traeger/image-placeholder-icon';
};

export const getPlaceholderImage = (assetObj: any, width: number | string) =>
  `${sharedStart}${assetObj.endpoint}/${assetObj.name}.png${width ? `?w=${width}` : ''}`;

export const convertDurationToTime = (dur: number) => {
  const minutes = Math.floor(dur / 60);
  let seconds: string | number = dur - minutes * 60;
  if (seconds < 10) {
    seconds = `0${seconds}`;
  }
  return `${minutes}:${seconds}`;
};
